import { HttpParameterCodec } from '@angular/common/http';

export class SearchHttpParameterCodec implements HttpParameterCodec {
  encodeKey(key: string) {
    return encodeURIComponent(key);
  }
  encodeValue(value: string) {
    return encodeURIComponent(value);
  }
  decodeKey(key: string) {
    return decodeURIComponent(key);
  }
  decodeValue(value: string) {
    return decodeURIComponent(value);
  }
}
